import { AgeGroup, AgeLimits } from 'constants/components'

/**
 * Returns the age group of a debtor based on their age.
 * Too young is considered 17 and below.
 * Young is considered 18 to 34.
 * Middle age is considered 35 to 54.
 * Old is considered 55 and above.
 * @param debtorsAge The age of the debtor.
 * @returns The age group of the debtor.
 */
export function getAgeGroupFromAge(debtorsAge: number) {
  if (debtorsAge <= AgeLimits.TOO_YOUNG_AGE_UNTIL) {
    return AgeGroup.TOO_YOUNG_AGE_GROUP
  }

  if (debtorsAge <= AgeLimits.YOUNG_AGE_UNTIL) {
    return AgeGroup.YOUNG_AGE_GROUP
  }

  if (debtorsAge <= AgeLimits.MIDDLE_AGE_UNTIL) {
    return AgeGroup.MIDDLE_AGE_GROUP
  }

  return AgeGroup.OLD_AGE_GROUP
}

export function isYoungOrMiddleAgeGroup(debtorsAge: number) {
  const ageGroup = getAgeGroupFromAge(debtorsAge)
  return (
    ageGroup === AgeGroup.YOUNG_AGE_GROUP ||
    ageGroup === AgeGroup.MIDDLE_AGE_GROUP
  )
}
